module.exports = __webpack_public_path__ + "img/bth_smartsetting.e9d458c5.png";